import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik'
import * as Yup from "yup";
//import { StepperComponent } from '../../../../../_metronic/assets/ts/components';
//import { ListUnitBranchLinkedService } from './components/listUnitBranchLinkedService';
//import { getUnitBranchAllSimple } from '../../../../services/unitBranchService';
import { ListPlantsLinkedService } from './components/listPlantsLinkedService';
import { getplantsAll } from '../../../../services/plantsService';
import { Loading } from '../../../components/Loadings/loading';
import { getTypeServicesAll } from '../../../../services/typeServices';
import { LoadingSpan } from '../../../components/Loadings/loadingSpan';
import { KTSVG } from '../../../../../_metronic/helpers';
import { useToast } from '../../../components/Toats';
import { useAuth } from '../../../../modules/auth';
import { postReportServiceOne } from '../../../../services/reportService';
import { getUnitBranchAllSimple } from '../../../../services/unitBranchService';
import { useQuery } from 'react-query';
import useSize from '../../../../hooks/useSize';

type Props = {
    refreshPage : boolean; 
    setRefreshPage: any;
}

type DataForm = {
    description: string | null,
    //date: Date | null,
    status: string | null,
    idUnitBranch: string | null,
    idTypeService: string | null,
    idPlant: string | null,
    idClient: string | null,
}

const validationSchema = Yup.object().shape({
    description: Yup.string().required("Informe um nome para a filial"),
    status: Yup.string().required("Informe um nome para a filial"),
    idUnitBranch: Yup.string().required("Informe um nome para a filial"),
    idTypeService: Yup.string().required("Informe um nome para a filial"),
    idPlant: Yup.string().required("Informe um nome para a filial"),
    idClient:  Yup.string()
 });

export function RequestService({refreshPage, setRefreshPage} : Props) {
    const { toggleToast } = useToast();
    const [hasError, setHasError] = useState(false)
    const [loading] = useState<boolean>(false);
    const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);
    const {currentUser} = useAuth();
    const {width: largura} = useSize()

    const [initialValues] = useState<DataForm>({
        description: null,
        status: "PENDENTE",
        idUnitBranch: null,
        idTypeService: null,
        idPlant: null,
        idClient: currentUser && currentUser?.client ? currentUser.client.id : null
    })

    const checkInputs = (): boolean => {
        if (!formik.values.description) {
          return false
        }
        return true
    }

    const submit = () => {
        postServices()
    }

    const nextStep = () => {
        setHasError(false)
        if (!checkInputs()) {
            setHasError(true)
            return
        }
        submit()
    }
    
    const formik = useFormik({
        initialValues,
        validationSchema,
        validateOnChange: false,
        onSubmit: nextStep,
    });


    const { data: unitBranchs = [], isLoading: loadingUnitBranchs } = useQuery<any>(
        ["getUnitBranchsAll"],
        async () => {
            const myUnitBranchs = await getUnitBranchAllSimple();
            if(myUnitBranchs && myUnitBranchs.length > 0){
                formik.setFieldValue("idUnitBranch", myUnitBranchs[0].id);
            }
            return myUnitBranchs
        },
        {
          onError: (error) => {
            console.log(error)
            toggleToast("Erro ao buscar a lista de unidades. ", "error")
          },
        }
    )

    const { data: typeServices = [], isLoading: loadingTypeServices } = useQuery<any>(
        ["getTypeServicesAll"],
        async () => {
            const myTypeServices = await getTypeServicesAll()
          return myTypeServices
        },
        {
          onError: (error) => {
            console.log(error)
            toggleToast("Erro ao buscar os tipos de serviços. ", "error")
          },
        }
    )

    const { data: plants = [], isLoading: loadingPlants } = useQuery<any>(
        ["getPlantsAll", formik.values.idUnitBranch],
        async () => {
            const myPlants = await getplantsAll(`?unitBranch=${formik.values.idUnitBranch ? formik.values.idUnitBranch : ""}`)
            return myPlants
        },
        {
          onError: (error) => {
            console.log(error)
            toggleToast("Erro ao buscar a lista de usinas. ", "error")
          },
        }
    )

    const postServices = async () => {
        try {
            setLoadingSubmit(true)
            const myBody = {
                description: formik.values.description,
                status: "PENDENTE",
                idUnitBranch: formik.values.idUnitBranch,
                idTypeService: formik.values.idTypeService,
                idPlant: formik.values.idPlant,
                idClient: formik.values.idClient
            }
            await postReportServiceOne(myBody)
            toggleToast("Sucesso ao solicitar o serviço. ", "success")

        } catch (error) {
            console.log(error)
            toggleToast("Erro ao solicitar o serviço. ", "error")
    
        }finally{
            formik.setValues(initialValues)
            setRefreshPage(prevAtivo => !prevAtivo);
            setLoadingSubmit(false)
            // formik.setValues(initialValues)
        }
    }
    
    if (loading && loadingPlants) {
        return (
          <div style={{display: 'flex', justifyContent: 'center', height: '15rem', alignItems: 'center'}}>
            <Loading myClass='spinner-border' style={{width: '3rem', height: '3rem'}}/>
          </div>
        );
    }

    return (
        <div style={largura < 1200 ? {padding: '0.5rem'} : {padding: '2rem'}}>
            <div style={
                largura < 1200 
                ? {overflow: 'auto', height: '50vh', marginBottom: '1rem'}
                : {overflow: 'auto', minHeight: '20rem', maxHeight: '50vh'}
            }
            >
                <div style={{display: 'flex', gap: '1rem'}}>
                    <div className='fv-row mb-10 mt-5' style={{flex: '1'}}>
                        <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                            <span className='required'>Filial</span>
                            <i
                                className='fas fa-exclamation-circle ms-2 fs-7'
                                data-bs-toggle='tooltip'
                                title='Selecione para qual filial será a solicitação. '
                            ></i>
                        </label>
                        <select
                            className='form-select'
                            data-kt-select2='true'
                            data-placeholder='Select option'
                            data-allow-clear='true'
                            //disabled={loadingSubmit ? true : formik.values.idUnitBranch ? false : true}
                            disabled={loadingSubmit}
                            value={formik.values.idUnitBranch ? formik.values.idUnitBranch : ''}
                            onChange={formik.handleChange("idUnitBranch")}
                        >
                        <option value={''}></option>
                        {unitBranchs && unitBranchs.map((unitBranch: any) => {
                            return (
                                <option key={unitBranch.id} value={unitBranch.id}>{unitBranch.companyName}</option>
                            )
                        })}
                        </select>
                        {!formik.values.idUnitBranch && hasError ? (
                            <div className='fv-plugins-message-container'>
                                <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                                    Informe uma unidade que realizará o atendimento.
                                </div>
                            </div>
                        ) : <></>}
                    </div>
                </div>

                <div style={{display: 'flex', gap: '1rem', justifyContent: 'space-between', marginBottom: '2rem'}}>
                    <div style={{flex: '1'}}>
                        <ListPlantsLinkedService 
                            plants={plants} 
                            className="bg-light" 
                            formik={formik}
                            hasError={hasError} 
                        />
                        {!formik.values.idPlant && hasError ? (
                            <div className='fv-plugins-message-container mt-2'>
                                <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                                    Informe a usina na qual o serviço será realizado.
                                </div>
                            </div>
                        ) : <></>}
                    </div>
                </div>

                <div style={{display: 'flex', gap: '1rem', flexDirection: largura < 1200 ? 'column' : 'row'}}> 
                    <div className='fv-row mb-10' style={{flex: '1'}}>
                        <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                            <span className='required'>Tipo de serviço</span>
                                <i
                                className='fas fa-exclamation-circle ms-2 fs-7'
                                data-bs-toggle='tooltip'
                                title='Selecione qual unidade prestará o serviço para então escolher algum serviço prestado pela mesma. '
                                ></i>
                        </label>
                        <select
                            className='form-select'
                            data-kt-select2='true'
                            data-placeholder='Select option'
                            data-allow-clear='true'
                            //disabled={loadingSubmit ? true : formik.values.idUnitBranch ? false : true}
                            disabled={loadingSubmit}
                            value={formik.values.idTypeService ? formik.values.idTypeService : ''}
                            onChange={formik.handleChange("idTypeService")}
                        >
                        <option value={''}></option>
                        {typeServices && typeServices.map((myTypeService: any) => {
                            return (
                            <option key={myTypeService.id} value={myTypeService.id}>{myTypeService.description}</option>
                            )
                        })}
                        </select>
                        {!formik.values.idTypeService && hasError ? (
                            <div className='fv-plugins-message-container'>
                                <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                                    Informe o serviço que será realizado.
                                </div>
                            </div>
                        ) : <></>}
                    </div>
                </div>

                <div style={{display: 'flex', gap: '1rem'}}> 
                    <div className='fv-row mb-10' style={{flex: '1'}}>
                        <label className='d-flex align-items-center fs-6 fw-semibold mb-2'>
                            <span >Descrição</span>
                                <i
                                    className='fas fa-exclamation-circle ms-2 fs-7'
                                    data-bs-toggle='tooltip'
                                    title='Descreva com mais detalhes o serviço'
                                ></i>
                        </label>
                        <input
                            style={{height: '20rem'}}
                            type='text'
                            className='form-control form-control-lg'
                            name='endPeriod'
                            placeholder=''
                            disabled={loadingSubmit}
                            value={formik.values.description ? formik.values.description : ""}
                            onChange={formik.handleChange("description")}
                        />
                        {/* {!formik.values.description && hasError && (
                        <div className='fv-plugins-message-container'>
                            <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                            Informe uma descrição para o tipo de serviço
                            </div>
                        </div>
                        )} */}
                    </div>
                </div>

            </div>
            
            <div style={{display: 'flex', justifyContent: 'end', paddingTop: largura < 1200 ? '0.5rem' : '1rem'}}>
                <button
                    type='button'
                    className='btn btn-lg btn-primary'
                    disabled={loadingSubmit || !formik.values.idTypeService || !formik.values.idPlant}
                    //data-kt-stepper-action='submit'
                    onClick={nextStep}
                    >
                        {"Solicitar Serviço" }{' '}
                    {
                        loading ? 
                        <LoadingSpan style={{marginLeft: '0.5rem'}}/>
                        :
                        <KTSVG
                            path='/media/icons/duotune/arrows/arr064.svg'
                            className='svg-icon-3 ms-2 me-0'
                        />
                    }
                </button>
            </div>
        </div>
    );
}

// function toggleToast(arg0: string, arg1: string) {
//     throw new Error('Function not implemented.');
// }
